import { Box, Typography, Paper, Chip } from "@mui/material";
import dayjs from "dayjs";

const STATUS_COLOR = { pending: "warning", approved: "success", paid: "success", flagged: "error" };

export default function EntryCard({ entry }) {
  const deliverableTypeName =
    entry.deliverableType && typeof entry.deliverableType === "object"
      ? entry.deliverableType.name
      : typeof entry.deliverableType === "string"
      ? entry.deliverableType
      : null;

  const deliverableNotes = entry.deliverableDescription || entry.description || null;

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 1,
        }}
      >
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          {entry.workType === "time" ? (
            <>
              <Typography variant="subtitle2">
                {entry.start ? dayjs(entry.start).format("MMM D, YYYY h:mm A") : "—"}
                {" – "}
                {entry.end ? dayjs(entry.end).format("h:mm A") : "—"}
              </Typography>
              {entry.hoursWorked != null && (
                <Typography variant="body2" color="text.secondary">
                  {entry.hoursWorked} hrs
                </Typography>
              )}
              {entry.description && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    mt: 0.5,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {entry.description}
                </Typography>
              )}
            </>
          ) : (
            <>
              {deliverableTypeName && (
                <Typography variant="subtitle2" noWrap>
                  {deliverableTypeName}
                </Typography>
              )}
              {entry.date && (
                <Typography variant="body2" color="text.secondary">
                  {dayjs(entry.date).format("MMM D, YYYY")}
                </Typography>
              )}
              {deliverableNotes && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    mt: 0.5,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {deliverableNotes}
                </Typography>
              )}
            </>
          )}
          {entry.status === "paid" && entry.paidAt && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5 }}
            >
              Paid {dayjs(entry.paidAt).format("MMM D, YYYY")}
            </Typography>
          )}
          {entry.adminNotes && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5, fontStyle: "italic" }}
            >
              Note: {entry.adminNotes}
            </Typography>
          )}
        </Box>
        <Chip
          label={entry.status}
          color={STATUS_COLOR[entry.status] || "default"}
          size="small"
          sx={{ flexShrink: 0 }}
        />
      </Box>
    </Paper>
  );
}
